module.exports = __webpack_public_path__ + "img/fellowfinancebusiness.6226d89.png";